import { Interessent, KontaktTyp } from '../../kunde/api/types';

/**
 * Wird von Funnel und Tabelle gemeinsam benutzt: die Funnel-Zahlen beziehen sich damit auf exakt
 * die Datensätze, die in der Tabelle stehen können.
 */
export const filterInteressentenBySearch = (interessenten: Interessent[], search: string) => {
  const normalizedSearch = search.trim().toLocaleLowerCase('de-DE');

  return interessenten.filter(interessent => {
    if (interessent.typ !== KontaktTyp.INTERESSENT) {
      return false;
    }

    if (!normalizedSearch) {
      return true;
    }

    return [
      interessent.organisation,
      interessent.operativerAnsprechpartner,
      interessent.email,
      interessent.telefonnummer,
      interessent.angebotsnummer,
      interessent.strasse,
      interessent.hausnummer,
      interessent.adresszusatz,
      interessent.postleitzahl,
      interessent.stadt,
    ].some(value => value?.toLocaleLowerCase('de-DE').includes(normalizedSearch));
  });
};
